import { IDocumentFolderModel } from '@api/models';
import { deleteDocumentFolder } from '@api/services/document.service';
import { useMutation } from '@tanstack/react-query';

interface DeleteFolderOptions {
    clientId: string;
    folder: IDocumentFolderModel;
}

const useDeleteFolderForm = (options: DeleteFolderOptions) => {
    const { clientId, folder } = options;

    const deleteFolderMutation = useMutation(() => deleteDocumentFolder(clientId, folder._id));

    const submit = async () => {
        await deleteFolderMutation.mutateAsync();
    };

    return {
        isLoading: deleteFolderMutation.isLoading,
        submit,
    };
};
export default useDeleteFolderForm;
